import { render, staticRenderFns } from "./UserArticlesList1.vue?vue&type=template&id=1a6fdd78&"
import script from "./UserArticlesList1.vue?vue&type=script&lang=js&"
export * from "./UserArticlesList1.vue?vue&type=script&lang=js&"
import style0 from "./UserArticlesList1.vue?vue&type=style&index=0&id=1a6fdd78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports